<div id="kt_app_header" class="app-header" data-kt-sticky="true" data-kt-sticky-activate="{default: true, lg: true}"
  data-kt-sticky-name="app-header-minimize" data-kt-sticky-offset="{default: '200px', lg: '0'}"
  data-kt-sticky-animation="false">
  <!--begin::Header container-->
  <div class="app-container container-fluid d-flex align-items-stretch justify-content-between"
    id="kt_app_header_container">
    <!--begin::Sidebar mobile toggle-->
    <div class="d-flex align-items-center d-lg-none ms-n3 me-1 me-md-2" title="Show sidebar menu">
      <div class="btn btn-icon btn-active-color-primary w-35px h-35px" id="kt_app_sidebar_mobile_toggle">
        <i class="ki-duotone ki-abstract-14 fs-2 fs-md-1">
          <span class="path1"></span>
          <span class="path2"></span>
        </i>
      </div>
    </div>
    <!--end::Sidebar mobile toggle-->
    <!--begin::Mobile logo-->
    <div class="logo d-flex align-items-center flex-grow-1 flex-lg-grow-0">
      <a href="/accueil" class="d-lg-none">
        <img alt="Logo" src="/assets/media/logos/wegestu.png" class="h-30px" />
      </a>
    </div>
    <!--end::Mobile logo-->
    <!--begin::Header wrapper-->
    <div class="d-flex align-items-stretch justify-content-between flex-lg-grow-1" id="kt_app_header_wrapper">
      <!--begin::Menu wrapper-->
      <div class="app-header-menu app-header-mobile-drawer align-items-stretch" data-kt-drawer="true"
        data-kt-drawer-name="app-header-menu" data-kt-drawer-activate="{default: true, lg: false}"
        data-kt-drawer-overlay="true" data-kt-drawer-width="250px" data-kt-drawer-direction="end"
        data-kt-drawer-toggle="#kt_app_header_menu_toggle" data-kt-swapper="true"
        data-kt-swapper-mode="{default: 'append', lg: 'prepend'}"
        data-kt-swapper-parent="{default: '#kt_app_body', lg: '#kt_app_header_wrapper'}">
        <!--begin::Menu-->
        <a id="kt_app_sidebar_toggle" href="#" class="menu-link app-sidebar-toggle mr-2" data-kt-toggle="true"
        data-kt-toggle-state="active" data-kt-toggle-target="body" data-kt-toggle-name="app-sidebar-minimize">
        <svg width="21" height="16" viewBox="0 0 21 16" class="menu-icon" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M0 14.7368C0 15.4358 0.58625 16 1.3125 16H15.3125C16.0387 16 16.625 15.4358 16.625 14.7368C16.625 14.0379 16.0387 13.4737 15.3125 13.4737H1.3125C0.58625 13.4737 0 14.0379 0 14.7368ZM15.3125 2.52632H1.3125C0.58625 2.52632 0 1.9621 0 1.26316C0 0.564211 0.58625 0 1.3125 0H15.3125C16.0387 0 16.625 0.564211 16.625 1.26316C16.625 1.9621 16.0387 2.52632 15.3125 2.52632ZM19.6875 9.26316H5.6875C4.96125 9.26316 4.375 8.69895 4.375 8C4.375 7.30105 4.96125 6.73684 5.6875 6.73684H19.6875C20.4137 6.73684 21 7.30105 21 8C21 8.69895 20.4137 9.26316 19.6875 9.26316Z"
            fill="white" />
        </svg>

      </a>

        <!--end::Menu-->
      </div>
      <!--end::Menu wrapper-->
      <!--begin::Navbar-->
      <div class="app-navbar flex-shrink-0">
        <!--begin::Search-->

        <!--end::Search-->
        <!--begin::Activities-->
        <div class="app-navbar-item ms-1 icon-notif" (click)="toggleMenuLink($event, 'message')" (mouseover)="openMenu()" (mouseleave)="closeMenu()">
          <!--begin::Menu- wrapper-->
          <div class="w-35px h-35px cursor-pointer" data-kt-menu-trigger="{default: 'click', lg: 'click'}" data-kt-menu-attach="parent"
            data-kt-menu-placement="bottom-end" id="kt_menu_item_wow" (click)="toggleDropdownmessage()">
            <svg width="20" height="28" viewBox="0 0 18 14" class="messagerie-icon" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M10.4324 8.92397C9.98762 9.21962 9.47101 9.37589 8.93837 9.37589C8.40577 9.37589 7.88916 9.21962 7.44441 8.92397L0.119032 4.0544C0.078388 4.02737 0.0387855 3.99921 0 3.97025V11.9496C0 12.8644 0.744573 13.5905 1.64567 13.5905H16.231C17.1485 13.5905 17.8767 12.8481 17.8767 11.9496V3.97021C17.8378 3.99924 17.7982 4.02748 17.7574 4.05453L10.4324 8.92397Z"
                fill="white" />
              <path
                d="M0.700057 3.18525L8.02543 8.05486C8.30273 8.2392 8.62053 8.33135 8.93834 8.33135C9.25617 8.33135 9.574 8.23916 9.8513 8.05486L17.1767 3.18525C17.615 2.89402 17.8767 2.40662 17.8767 1.88057C17.8767 0.976062 17.1387 0.240234 16.2316 0.240234H1.64512C0.738014 0.24027 0 0.976098 0 1.88144C-5.64528e-08 2.40662 0.261731 2.89402 0.700057 3.18525Z"
                fill="white" />
            </svg>


          </div>
          <div *ngIf="unreadMessageCount > 0" class="message-icon">
            {{ unreadMessageCount }}
          </div>
          <!--begin::Menu-->
          <div class="sub-menu-notif notif-content messages-content"  [ngClass]="{'show-block': openMenuId === 'message', 'hide': openMenuId !== 'message'}" data-kt-menu="true"
            id="kt_menu_notifications">
            <!--begin::Heading-->
            <div class="d-flex flex-column bgi-no-repeat rounded-top">
              <!--begin::Title-->
              <div class="notif-header">
                <h3 class="notif-title">Messages</h3>
              </div>
              <!--end::Title-->
              <!--begin::Tabs-->
                <div class="tab-content">
                  <!--begin::Tab panel-->
                  <div class="notif" id="kt_topbar_notifications_1" role="tabpanel">
                    <!--begin::Items-->
                    <div class="scroll-y mh-325px px-8"  *ngFor="let message  of messages; let i = index" >
                      <div class="one-notif">
                        <div class="d-flex flex-stack py-4" (click)="viewMessage(message?.emitter_id)">
                          <!--begin::Section-->
                          <div class="d-flex align-items-center cursor-pointer">
                            <div class="symbol symbol-35px me-4">
                              <img *ngIf="message?.image_url; else noImageUser"
                                  src="{{ getUserImage(message) }}" class="user-img" alt="user" 
                              />
                              <ng-template #noImageUser>
                                  <span class="symbol-label bg-light-danger text-danger fs-6 fw-bolder">
                                      {{message?.full_name?.charAt(0) | uppercase}}
                                  </span>
                              </ng-template>
                            </div>
                            <!--end::Symbol-->
                            <!--begin::Title-->
                            <div class="mb-0 me-2">
                              <div class="msg-content">
                                <div class="notif-username">
                                  {{message?.full_name}}
                                  <ng-container *ngIf="message?.Role">({{message?.Role}})</ng-container>
                                </div>
                                <div class="notif-body"> 
                                  {{ message?.message}}
                                </div>
  
                              </div>
                              <div class="text-gray-400 notif-date"><i class="fa-regular fa-clock"></i> {{message?.created_at | date:'dd/MM/yyyy HH:mm'}}</div>
                            </div>
                            <!--end::Title-->
                          </div>
                          <!--end::Section-->
                        </div>
                      </div>  
                    </div>
                    <div class="empty-message" *ngIf="!messages?.length">
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-message-square-dot"><path d="M11.7 3H5a2 2 0 0 0-2 2v16l4-4h12a2 2 0 0 0 2-2v-2.7"/><circle cx="18" cy="6" r="3"/></svg>
                      Vous n’avez pas de nouveaux messages
                    </div>
                    <div class="py-3 text-center border-top cursor-pointer" (click)="viewAllChats()">
                      <a class="msg-see">Voir tous les messages</a>
                    </div>
                    <!--end::View more-->
                  </div>
                </div>
              <!--end::Tabs-->
            </div>
            <!--end::Heading-->
            <!--begin::Tab content-->

          </div>
          <!--end::Menu-->
          <!--end::Menu wrapper-->
        </div>
        <!--end::Activities-->
        <!--begin::Notifications-->
        <div class="app-navbar-item ms-1 icon-notif" (click)="toggleMenuLink($event, 'notif')">
          <!--begin::Menu- wrapper-->
          <div class="w-35px h-35px"
            data-kt-menu-trigger="{default: 'click', lg: 'click'}" data-kt-menu-attach="parent"
            data-kt-menu-placement="bottom-end" id="kt_menu_item_wow" (click)="toggleDropdown()">
            <svg width="20" height="28" viewBox="0 0 24 28" class="notif-icon"  xmlns="http://www.w3.org/2000/svg" style="cursor: pointer;">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M9.75 3.2834C5.86824 4.28202 3 7.80437 3 11.9996V17.9991C3 18.5519 2.55087 19 2.00104 19C0.895898 19 0 19.8977 0 21C0 22.1046 0.897026 23 2.00495 23H21.9951C23.1024 23 24 22.1023 24 21C24 19.8954 23.0999 19 21.999 19C21.4472 19 21 18.5554 21 17.9991V11.9996C21 7.80603 18.1324 4.28236 14.25 3.28343V2.25043C14.25 1.00462 13.2426 0 12 0C10.7599 0 9.75 1.00755 9.75 2.25043V3.2834ZM8.5 24H15.5C15.5 25.933 13.933 27.5 12 27.5C10.067 27.5 8.5 25.933 8.5 24Z" fill="#fff"/>
              </svg>
              
            
          </div>
          <div *ngIf="unreadNotificationCount > 0" class="notification-icon">
            {{ unreadNotificationCount }}
          </div>
          <!--begin::Menu-->
          <!-- <div class="menu menu-sub menu-sub-dropdown menu-column w-350px w-lg-375px notif" data-kt-menu="true"
            id="kt_menu_notifications"> -->
            <div class="sub-menu-notif notif-content messages-content" [ngClass]="{'show-block': openMenuId === 'notif', 'hide': openMenuId !== 'notif'}"
            data-kt-menu="true"
            id="kt_menu_notifications" #notificationDropdown>
            <!--begin::Heading-->
            <div class="d-flex flex-column bgi-no-repeat rounded-top ">
              <!--begin::Title-->
              <div class="notif-header rounded-top">
                <!--begin::Title-->
                <h3 class="notif-title">Notifications ({{unreadNotificationCount}})</h3>
                <!--end::Title-->
                <!--begin::Tabs-->
                <!--end::Tabs-->
              </div>
              <!--end::Title-->
              <!--begin::Tabs-->
             
              <ul class="">
                <div class="">
                  
                  <!--begin::Tab panel-->
                  <!-- <div class="notif">
                   
                    <div class="scroll-y mh-325px" >
                      <div class="one-notif mh-325px px-8" *ngFor="let notification  of notifications?.slice(0,5); let i = index" [ngStyle]="{'background-color': !notification.read ? 'rgba(232, 246, 252, 0.53)' : ''}">
                        <div class="d-flex flex-stack py-3" (click)="notificationRedirection(notification,i)">
                        <div class="d-flex align-items-center blockNotification cursor-pointer" (click)="notificationRedirection(notification,i)">
                          <div class="symbol notif-image me-4">
                            <img *ngIf="notification?.sender?.image_url" src="{{base_url_img + notification?.sender?.image_url}}"  alt="user" width="75px" style="border-radius: 50%;" />
                            <img  *ngIf="!notification?.sender?.image_url || notification?.sender?.image_url=='null'"  src="/assets/media/icons/avatar.jpg"  alt="user" width="75px" />
                          </div>
                          <div class="mb-0 me-2">
                            <div class="notif-content">
                              <div class="notif-username fw-bold">{{notification?.sender?.last_name}} {{notification?.sender?.first_name}} 
                              </div>
                              <div class="notif-body" > {{notification?.message}} </div>
                              <div class="tools">
                                <td class="actions">
                                  <div class="tools">
                                  </div>
                                </td>
                              </div>
                            </div>
                            <div class="text-gray-400 notif-date"><i class="fa-regular fa-clock"></i> {{notification?.created_at |date : 'dd/MM/yyyy  HH:mm:ss'}}</div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div  *ngIf="!notifications?.length" class="py-3 text-center border-top">
                      <a routerLink="/notifications" class="btn ">liste de notifications est actuellement vide
                      </a>
                    </div>
                    </div>
                    <div *ngIf="notifications?.length" class="py-3 text-center border-top" (click)="viewAllNotifications()">
                      <a  class="notif-see cursor-pointer"  data-bs-dismiss="modal" aria-label="Close" (click)="toggleDropdown()">Voir toutes les notifications 
                      </a>
                    </div>
                    
                  </div> -->

                  <div class="notif">
                    <!--begin::Items-->
                    
                    <div class="scroll-y mh-407px">
                      <div class="one-notif"  *ngFor="let notification  of notificationsNotRead let i = index">
                        <div class="d-flex flex-stack py-3" >
                          <!--begin::Section-->
                          <div class="d-flex align-items-start blockNotification" (click)="notificationRedirection(notification,i)">
                            <!--begin::Symbol-->
                            <div class="notif-img symbol me-4">
                              <img *ngIf="notification?.sender?.image_url" src="{{base_url_img + notification?.sender?.image_url}}" class="user-img" alt="user" />
                              <!-- <img *ngIf="notification?.sender?.company?.logo" src="{{base_url_img_company + notification?.sender?.company?.logo}}" class="user-img" alt="user" /> -->
                              <img  *ngIf="!notification?.sender?.image_url && !notification?.sender?.company?.logo" src="/assets/media/logos/logo-avatar.jpg" class="user-img" alt="user" />
                            </div>
                            <!--end::Symbol-->
                            <!--begin::Title-->
                            <div class="mb-0 me-2">
                              <div class="notif">
                                <div class="notif-username fw-bold" *ngIf="!notification?.sender?.company?.name && notification.state!='17'">{{notification?.sender?.first_name}}  {{notification?.sender?.last_name}} 
                                </div>
                                <div class="notif-username fw-bold" *ngIf="notification?.sender?.company?.name">{{notification?.sender?.company?.name}}
                                </div>
                                <div class="notif-username fw-bold" *ngIf="notification.state=='17'">Demande accepter ({{!notification.read ? "Non Lu":'Lu'}})
                                </div>
                                
                                <div class="notif-body"> {{notification?.message}} </div>
                                <div class="tools">
                                  <td class="actions">
                                    <div class="tools">
                                    </div>
                                  </td>
                                </div>
                              </div>
                              <div class="text-gray-400 notif-date"> {{notification?.created_at |date : 'dd/MM/yyyy  HH:mm'}}</div>
                            </div>
                            <!--end::Title-->
                          </div>
                          <!--end::Section-->

                        </div>
                      </div>
                    </div>
                    <div class="empty-message" *ngIf="!notificationsNotRead?.length">
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-bell-dot"><path d="M10.268 21a2 2 0 0 0 3.464 0"/><path d="M13.916 2.314A6 6 0 0 0 6 8c0 4.499-1.411 5.956-2.74 7.327A1 1 0 0 0 4 17h16a1 1 0 0 0 .74-1.673 9 9 0 0 1-.585-.665"/><circle cx="18" cy="8" r="3"/></svg>
                      Vous n’avez pas de nouvelles notifications
                     </div>
                    <div class="py-3 text-center border-top" (click)="viewAllNotifications()">
                      <a  class="notif-see"data-bs-dismiss="modal" aria-label="Close" >Voir toutes les notifications
                      </a>
                    </div>
                    <!--end::View more-->
                  </div>
                </div>
              </ul>
              <!--end::Tabs-->
            </div>
            <!--end::Heading-->
            <!--begin::Tab content-->

          </div>
          <!--end::Menu-->
          <!--end::Menu wrapper-->
        </div>
        <div class="app-navbar-item ms-1 icon-notif" [ngbTooltip]="roleUser[0] === 'ESNNAB' ? 'Votre abonnement n\'inclut pas cette fonctionnalité' : null" (click)="roleUser[0] !== 'ESNNAB' && toggleMenuLink($event, 'wegestu')" (mouseover)="openMenu()" (mouseleave)="closeMenu()" [ngClass]="{'disabled-setting':roleUser[0] === 'ESNNAB'}">
          <i class="fa-solid fa-gear" placement="bottom" ></i>
          <div class="sub-menu-notif" [ngClass]="{'show-block': openMenuId === 'wegestu', 'hide': openMenuId !== 'wegestu'}"
          data-kt-menu="true"
          id="kt_menu_notifications"  #notificationDropdown>
            <!--begin::Heading-->
            <div class="d-flex flex-column bgi-no-repeat rounded-top">
              <div class="notif-header d-flex flex-column bgi-no-repeat rounded-top"   >
                <div class="notif-title help-content mb-0">Paramètres</div>
              </div> 
              <ul class="help-menu">
                <li  [routerLink]="subscriptionCanAccess('CRA') ? ['/paramètres/type-activity-cra'] : null"
                    [ngClass]="{'disabled-setting': !subscriptionCanAccess('CRA')}"
                    >
                    <span>Type d’activité</span> 
                  </li>
                <!-- <li routerLink="/paramètres/pages" ><span>Pages</span> </li> -->
                <li routerLink="/paramètres/mailing" ><span>Mailing</span> </li>
                <li routerLink="/paramètres/permissions" ><span> Rôle et permission</span> </li>
              </ul>
              <!--end::Tabs-->
            </div>
            <!--end::Heading-->
            <!--begin::Tab content-->
          </div>
        </div>
        <div class="app-navbar-item ms-1 icon-notif" (click)="toggleMenuLink($event, 'help')" (mouseover)="openMenu()" (mouseleave)="closeMenu()">
          <i class="fa-solid fa-circle-question"></i>
          <div class="sub-menu-notif" [ngClass]="{'show-block': openMenuId === 'help', 'hide': openMenuId !== 'help'}"
          data-kt-menu="true"
          id="kt_menu_notifications"  #notificationDropdown>
            <!--begin::Heading-->
            <div class="d-flex flex-column bgi-no-repeat rounded-top ">
              <div class="notif-header d-flex flex-column bgi-no-repeat rounded-top">
                <div class="notif-title help-content mb-0">Support & Assistance</div>
              </div> 
              <ul class="help-menu">
                <li routerLink="/evaluer-wegestu" ><span> Évaluer Wegestu </span> </li>
                <li routerLink="/contacter-nous" ><span> Contacter WEGESTU </span></li>
                 <li routerLink="/faq-esn" ><span>FAQ </span> </li>
                  <li routerLink="/list-reviews" ><span>Les Avis</span> </li>
                <li ><a href="https://wegestu.com/a-propos/" target="_blank"> A propos</a> </li>
                <!-- <li routerLink="/tuto" ><span>Tutos</span> </li> -->
              </ul>
              <!--end::Tabs-->
            </div>
            <!--end::Heading-->
            <!--begin::Tab content-->
          </div>
        </div>
      </div>
      <div class="d-flex align-items-center justify-content-center">   
        <div class="d-column info-user ">
          <div class="name">
            <span>
           <span placement="bottom" [ngbTooltip]="name" *ngIf="roleUser[0] === 'ESNAB' || roleUser[0] === 'ESNNAB'">
             {{ name }}
            </span>
            </span>
            <span>
              <span placement="bottom" [ngbTooltip]="firstnameinter + ' ' + lastnameinter" *ngIf="roleUser[0] !== 'ESNAB' || roleUser[0] !== 'ESNNAB'"> {{firstnameinter}}  {{lastnameinter}}</span>
            </span>
          </div>
          <div class="role" placement="bottom" [ngbTooltip]="entreprise" *ngIf="roleUser[0] !== 'ESNAB' && roleUser[0] !== 'ESNNAB'" >
          {{entreprise}} -
         </div>


          <!-- <div class="role sss"  *ngIf="roleUser[0] !== 'ESNAB' && roleUser[0] !== 'ESNNAB'" >
          {{entreprise}} -
         </div> -->
         <div class="role"  *ngIf="roleUser[0] !== 'ESNAB' || roleUser[0] !== 'ESNNAB'" >
          {{roleintervenant}}
         </div>
        </div>
        <div *ngIf="roleUser[0] === 'ESNAB' || roleUser[0] === 'ESNNAB'" class="app-navbar-item ms-1 icon-notif" id="kt_header_user_menu_toggle">
          <!--begin::Menu wrapper-->
          <div class=" symbol symbol-35px " data-kt-menu-trigger="click"
            data-kt-menu-attach="parent" data-kt-menu-placement="bottom-end">
            <img  src="{{url+'/api/Company/file/gallery_company/' + logo}}" alt="logo" class="user-img" width="50px">
           
          </div>
          
        </div>
        <div *ngIf="roleUser[0] && roleUser[0] !== 'ESNAB' && roleUser[0] !== 'ESNNAB'" class="app-navbar-item ms-1 icon-notif" id="kt_header_user_menu_toggle">
          <!--begin::Menu wrapper-->
          <div class=" symbol symbol-35px " data-kt-menu-trigger="click"
            data-kt-menu-attach="parent" data-kt-menu-placement="bottom-end">
           
            <img *ngIf="image !=='avatar.png'"
            src="{{
              url +
                '/api/User/file/gallery_users/' + image}} "
                alt="logo" class="user-img" width="50px"
          />
          <img *ngIf="image ==='avatar.png'" 
          src="../../../assets/media/avatar.png"
              alt="logo" class="user-img" width="50px"
        />
          </div>
        </div>
        <div class="dropdown-container app-navbar-item ms-1 icon-notif" (click)="toggleMenuLink($event, 'profile')">
          <div class="cursor-pointer symbol" data-kt-menu-trigger="click" data-kt-menu-attach="parent" data-kt-menu-placement="bottom-end">
            <button class="dropdown-toggle-button" (click)="toggleDropdownProfil()">
              <i class="fa fa-chevron-down" [ngClass]="{'fa-rotate-180': isDropdownOpen}"></i>
            </button>
            <div class="profile-link sub-menu-notif"  [ngClass]="{'show-block': openMenuId === 'profile', 'hide': openMenuId !== 'profile'}">
           
                <div class="menu-item d-flex profile-drop-menu menu-item-profile">
                  <img src="../assets/media/icons/user-profile.svg">
                  <div *ngIf="roleUser[0] && roleUser[0] !== 'ESNAB' && roleUser[0] !== 'ESNNAB'">
                    <!-- <a class="profile-drop-menu px-5" [routerLink]="['/acceuil/updateintervenant']" >Voir mon profil</a> -->
                    <a  class="profile-drop-menu" [routerLink]="['/profil-intervenant']" >Profil entreprise</a>
                  </div>
                  <div *ngIf="roleUser[0] === 'ESNAB' || roleUser[0] === 'ESNNAB'">
                    <!-- <a class="profile-drop-menu px-5" [routerLink]="['/acceuil/updateintervenant']" >Voir mon profil</a> -->
                    <a  class="profile-drop-menu" [routerLink]="['/profil-entreprise/details-profil']" >Profil entreprise</a>
                </div>
              
              <!--end::Menu item-->
              </div> 
            
              <div class="menu-item d-flex profile-drop-menu menu-item-profile">
                  <img src="../assets/media/icons/password-profile.svg">
                <div>
                   <a [routerLink]="['/change-mot-de-passe']" class="profile-drop-menu">Gérer mon compte</a>
                </div>
              </div>
              <div class="menu-item d-flex profile-drop-menu disconnect-link menu-item-profile">
                <div class="menu-item d-flex profile-drop-menu">
                  <img src="../assets/media/icons/disconnect-profile.svg">
                <div>
                  <span (click)="showLogoutConfirmation()">Se déconnecter</span>
              </div>
              </div>
            </div>
          </div>
          </div>  
      </div>
      </div>
  </div>
</div>

